import "./Toast.scss";

function Toast(props: any) {
    return(<div className="toast">{props.children}</div>);
}

export default Toast;